import type { Dictionnaire } from '../type';

export const sorties: Dictionnaire['sorties'] = {
  erreurs: {
    introuvable: '找不到该活动',
    titre: '给你的活动起个标题',
    lieu: '请填写集合地点',
    adresse: '请从建议列表中选择一个地址',
    horsZone: '请选择本地区所在国家内的地址。',
    lien: '这个链接无法打开：请检查，或留空',
    dateInvalide: '请选择有效的日期',
    datePassee: '这个日期已经过去了',
    heureDebut: '请填写开始时间',
    heureFin: '请填写结束时间',
    finDifferente: '结束时间必须与开始时间不同',
    passe: {
      inscrire: '已无法报名',
      valider: '已无法审批申请',
      modifier: '已无法修改',
      figee: '参与者名单已锁定',
      retirer: '已无法退出',
      reprendre: '已没有什么可以接手的了',
      supprimer: '已无法删除',
    },
    annuleFaute: '这个活动因参与人数不足已取消',
    complet: '名额已满，请先腾出一个名额再接受',
    pasInscrite: '此人没有报名这个活动',
    feuillePasFinie: '活动结束后才能确认出席',
    feuilleValidee: '这份出席表已经确认过了',
    note: '评分范围为 1 到 5',
    finApresDebut: '结束时间必须晚于开始时间',
    tropTard: '这个活动将在十小时内开始，已无法修改',
    creneauPasse: '这个时间段已经过去了',
    organisateurReste: '你是这个活动的组织者，不能移除自己',
    sansGroupe: '这个活动没有群组',
    seulOrganisateur: '只有组织者可以管理参与者',
    organisateurPart: '你是这个活动的组织者：请转交或删除它',
    autreQuelquun: '请选择另一个人来接手这个活动',
    neParticipePas: '此人没有参加这个活动',
    nombreParticipants: (min: number, max: number) => `参与人数必须在 ${min} 到 ${max} 之间`,
    suspendu: (jusqua: number) =>
      `你有两次缺席且未提前告知：可在 ${new Date(jusqua).toLocaleDateString('zh-CN')} 重新报名`,
    estPasse: (raison: string) => `这个活动已经结束：${raison}`,
    creneauPris: (titre: string) => `你在这个时间已有安排：“${titre}”`,
  },
  carte: {
    inscrit: '已报名',
    enAttente: '待审批',
    complet: '已满',
    note: (note: string) => `组织者评分 ${note}/5`,
    participants: (n: number, max: number) => `${n}/${max} 位参与者`,
  },
  commun: {
    autresActions: '更多操作',
    lieu: '地点',
    date: '日期',
    participants: '参与者',
    monBillet: '我的票',
    enLigne: '线上',
    masquerQ: '隐藏这个活动？',
    masquer: '隐藏这个活动',
    actionImpossible: '暂时无法完成。',
  },
  fiche: {
    noteNonEnvoyee: '评分未能发送。',
    groupeImpossible: '无法打开群组',
    ecrireImpossible: '暂时无法给对方发消息。',
    desinscrireQ: '退出这个活动？',
    titre: '活动',
    adresseComplete: '完整地址',
    partager: '分享活动',
    retirerMasques: '取消隐藏',
    presenceEnregistree: '你的出席已记录。',
    montreLeCarre: '到场时把这个二维码给组织者看：它能确认你的出席。',
    passe: '这个活动已经结束',
    gerer: '管理我的活动',
    rejoindreGroupe: '加入群组',
    groupe: '活动群组',
    monAgenda: '我的日程',
    presenceConfirmee: '出席已确认',
    horaire: '时间',
    places: '名额',
    lien: '链接',
    lienApresInscription: '报名后可见',
    rejoindre: (hote: string) => `在 ${hote} 加入`,
    noteOrganisateur: '给组织者评分',
    commentCaSEstPasse: '这个活动怎么样？',
    noteSurCinq: '满分 5 分',
    langues: '语言',
    description: '介绍',
    organise: '组织者',
    prevenir: '如果不能来，请告诉组织者。两次缺席会让你一周内无法报名活动。',
    autresApresAcceptation: '你的报名通过后，才能看到其他参与者。',
    annulerDemande: '取消我的申请',
    meDesinscrire: '退出活动',
    listeAttente: '加入候补名单',
    demanderAParticiper: '申请参加',
    participer: '参加',
    gererDemandes: (n: number) => `管理 · ${n} 个申请`,
    suspendu: (jusqua: number) =>
      `两次缺席：可在 ${new Date(jusqua).toLocaleDateString('zh-CN')} 重新报名`,
    organisePar: (nom: string) => `由 ${nom} 组织`,
    ecrireA: (nom: string) => `给 ${nom} 发消息`,
    noteAide: (nom: string) => `给 ${nom} 评分。评分提交后无法撤回。`,
    surCinq: (n: number) => `${n}/5`,
    donnerQ: (n: number, nom: string) => `给 ${nom} ${n} 颗星？评分提交后无法修改。`,
    demandesEnAttente: (n: number) => `${n} 个申请等待你的回复。`,
  },
  gestion: {
    groupeImpossible: '群组未能创建。',
    passationImpossible: '暂时无法转交。',
    feuilleTousLa: '出席已确认。所有人都到场了。',
    validationImpossible: '暂时无法确认。',
    scan: {
      pasSirocco: '这不是 Sirocco 的二维码。',
      autreSortie: '这张票属于另一个活动。',
      pasInscrite: '此人没有报名这个活动。',
      impossible: '无法记录。',
      dejaPresent: (nom: string) => `${nom} 已被标记为出席。`,
      present: (nom: string) => `${nom} · 已出席`,
    },
    suppressionImpossible: '暂时无法删除。',
    quitter: '退出活动',
    supprimerQ: '删除这个活动？',
    supprimer: '删除活动',
    aQui: '你要把组织工作转交给谁？',
    modifier: '编辑活动',
    scanner: '扫描门票',
    reserve: '仅限组织者',
    reserveAide: '只有这个活动的组织者可以管理参与者。',
    tropTard: '来不及修改了：活动将在十小时内开始。',
    scannerUn: '扫描一张票',
    ouvrirGroupe: '打开群组',
    creerGroupe: '创建群组',
    personneAReunir: '没有可以拉进群的人',
    demandes: '申请',
    feuilleAVerifier: '待确认的出席表',
    feuilleAide: '打开参与者列表，勾选到场的人，然后确认。其他人将被记为缺席；两次缺席会让该成员一周内无法报名。',
    validerTousQ: '确认出席？所有人都被标记为出席。',
    valider: '确认出席',
    modificationImpossible: '修改未能保存。',
    champs: {
      titre: '标题',
      debut: '开始',
      fin: '结束',
    },
    placesGardees: '已报名的参与者保留名额。名额数量无法修改。',
    enregistrer: '保存',
    ouvertureCamera: '正在打开相机…',
    feuilleAbsents: (n: number) => `出席已确认。记录了 ${n} 人缺席。`,
    laisserQ: (nom: string) => `把组织工作转交给 ${nom}？`,
    valideeLe: (date: string) => `出席已于 ${date} 确认`,
    validerQ: (n: number) => `确认出席？将有 ${n} 人被记为缺席。`,
  },
  categories: {
    sport: '运动',
    culture: '文化',
    pro: '职业',
    food: '美食',
    asso: '社团',
    etudes: '学习',
    jeux: '游戏',
  },
  reserve: {
    titre: '仅限组织者',
  },
  creation: {
    impossible: '发布失败',
    titreSortie: '发起一次聚会',
    titreEvenement: '创建活动',
    publierSortie: '发布聚会',
    publierEvenement: '发布活动',
    type: '聚会类型',
    evenement: '活动',
    spontanee: '临时聚会',
    enLigne: '线上',
    affiche: '海报（可选）',
    choisirAffiche: '选择海报',
    retirerAffiche: '移除海报',
    quoi: '做什么？',
    titre: '标题',
    exempleSortie: '在钟楼喝咖啡',
    exempleEvenement: '五人制足球',
    categorie: '类别',
    horaires: '时间',
    heureDebut: '开始时间',
    heureFin: '结束时间',
    ouSurLeCampus: '在校园哪里？阶梯教室、教室、球场…',
    campusAile: (aile: string) => (aile.length <= 2 ? `${aile} 翼` : aile),
    campusEtage: (n: number) => (n === 0 ? '底层' : `${n + 1} 楼`),
    chercheAdresse: '搜索地址',
    lien: '加入链接（可选）',
    lienExemple: 'https://zoom.us/j/…',
    lienAide: '视频会议、Discord 频道等。只有报名的人才能在活动页面看到它。',
    placeSurLePlan: '已在地图上标出，点击可移动',
    placerSurLePlanBouton: '在校园地图上标出',
    annuaireMuet: '地址目录没有响应。请稍后再试。',
    aucuneAdresse: '没有找到地址。请加上街道或地点名称。',
    nombreParticipants: '参与人数',
    maximum: '上限',
    retirerPlace: '减少一个名额',
    ajouterPlace: '增加一个名额',
    seConfirme: '成团人数',
    abaisserSeuil: '降低最低人数',
    aucun: '无',
    releverSeuil: '提高最低人数',
    description: '介绍',
    descriptionExemple: '需要知道的事：水平、装备、集合地点…',
    validation: '审批参与者',
    langues: '使用语言',
    languesTitre: '使用的语言',
    languesMax: '最多三种语言。',
    languesChercher: '搜索语言',
    languesAucune: '没有匹配的语言。',
    languesTermine: '完成',
    languesNoms: { ary: '摩洛哥阿拉伯语', zgh: '柏柏尔语' },
  },
  filtres: {
    titre: '活动筛选',
    quand: '时间',
    du: '从',
    aPartirDu: '从',
    au: '到',
    jusquAu: '直到',
    distance: '距离',
    rayon: '我周围的范围',
    sansDistance: '未设置距离',
    sansPosition: '找不到你的位置。距离筛选需要你的位置。',
    nature: '类型',
    spontanees: '临时聚会',
    enLigne: '线上',
    categories: '类别',
    langues: '语言',
    toutesLangues: '所有语言',
    appliquer: '应用筛选',
    effacer: '清除',
    kilometres: (n: number) => `${n} 公里`,
  },
  liste: {
    rechercher: '搜索…',
    carte: '活动地图',
    agenda: '我的日程',
    creer: '创建活动',
    masques: '已隐藏的活动',
    filtreActif: '筛选 · 已开启筛选',
    filtrer: '筛选',
    unSansAdresse: '有 1 个聚会没有精确地址，未计入此范围。',
    aucun: '没有活动',
    elargir: '试试放宽类别。',
    personne: '这里还没有人发起聚会。',
    proposer: '发起一次聚会',
    pourToi: '为你推荐',
    toutes: '全部聚会',
    sansAdresse: (n: number) => `有 ${n} 个聚会没有精确地址，未计入此范围。`,
    rienAMoinsDe: (km: number) => `你周围 ${km} 公里内没有活动。试试扩大范围。`,
  },
  agenda: {
    onglets: {
      aVenir: '即将开始',
      jOrganise: '我组织的',
    },
    titre: '我的日程',
    semaine: '本周',
    plusTard: '以后',
    rien: '这里什么都没有',
    rienAide: '报名一次聚会或自己发起一次：它会出现在这里。',
    rienOrganise: '你组织的活动会出现在这里。',
    voir: '查看活动',
    proposer: '发起一次聚会',
  },
  participants: {
    titre: '参与者',
    reserveAide: '只有这个活动的组织者可以查看这份名单。',
    chercher: '搜索参与者',
    personne: '这个活动中没有叫这个名字的人。',
    present: '出席',
    organise: '组织者',
    absent: '缺席',
    retirerQ: (nom: string) => `把 ${nom} 移出活动？`,
    retirerPresence: (nom: string) => `取消 ${nom} 的出席`,
    estLa: (nom: string) => `${nom} 已到场`,
  },
  demandes: {
    titre: '申请',
    reserveAide: '只有这个活动的组织者可以处理申请。',
    chercher: '搜索申请',
    personne: '申请中没有叫这个名字的人。',
    aucune: '没有申请',
    aucuneAide: '参加申请会出现在这里。',
    ouvert: '只要还有名额，这个活动会自动接受所有人。',
    rang: (rang: number) => `名单第 ${rang} 位`,
    accepter: (nom: string) => `接受 ${nom}`,
    refuser: (nom: string) => `拒绝 ${nom}`,
  },
  miennes: {
    onglets: {
      inscrit: '已报名',
      organise: '我组织的',
      passes: '已结束',
    },
    vides: {
      inscrit: '你的报名会出现在这里。',
      organise: '你组织的活动会出现在这里。',
      passes: '已确认你出席的活动会出现在这里。',
    },
    titre: '我的活动与聚会',
    uneFeuille: '有 1 份出席表待确认',
    rien: '这里什么都没有',
    feuilles: (n: number) => `有 ${n} 份出席表待确认`,
  },
  masques: {
    titre: '已隐藏的活动',
    aucun: '没有隐藏的活动',
    aucunAide: '你在活动页面隐藏的活动会出现在这里。',
    remettre: '打开一个活动，即可把它放回你的列表。',
  },
};
